import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@mantine/core';
import useAuthStore from '../../../store/authStore';
import { toast } from 'sonner';
import { LogOut } from 'react-feather';

const Logout = () => {
  const navigate = useNavigate();
  const { logout } = useAuthStore();

  const handleLogout = () => {
    logout();
    toast.success('Logged out successfully');
    navigate('/login');
  };

  return (
    <Button
      variant="subtle"
      color="red"
      leftIcon={<LogOut size={16} />}
      onClick={handleLogout}
    >
      Logout
    </Button>
  );
};

export default Logout;
